// Small presentational primitives shared by every inventory form (dashboard
// add/edit/purchase/issue/adjust + the inline add-stock-item modal reused by
// the product form). Extracted verbatim from StoreInventoryDashboard so the
// two screens render identical fields.
import React from 'react'
import { UNIT_OPTIONS, type UnitMode } from '@/lib/inventory-units'

export function UnitSelector({ unitMode, unit, onModeChange, onUnitChange }: { unitMode: UnitMode; unit: string; onModeChange: (m: UnitMode) => void; onUnitChange: (u: string) => void }) {
  return (
    <div className="space-y-2">
      <div className="flex rounded-md overflow-hidden border">
        <button type="button" onClick={() => onModeChange('weight')}
          className={`flex-1 py-1.5 text-xs font-medium transition-colors ${unitMode === 'weight' ? 'bg-primary text-primary-foreground' : 'bg-background hover:bg-muted'}`}>
          By Weight
        </button>
        <button type="button" onClick={() => onModeChange('quantity')}
          className={`flex-1 py-1.5 text-xs font-medium transition-colors ${unitMode === 'quantity' ? 'bg-primary text-primary-foreground' : 'bg-background hover:bg-muted'}`}>
          By Quantity
        </button>
      </div>
      <select value={unit} onChange={e => onUnitChange(e.target.value)}>
        {UNIT_OPTIONS[unitMode].map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
    </div>
  )
}

export function FormField({ label, required, children }: { label: string; required?: boolean; children: React.ReactNode }) {
  return (
    <label className="block">
      <span className="text-sm font-medium">{label}{required && <span className="text-red-500 ml-0.5">*</span>}</span>
      <div className="mt-1 [&_input]:w-full [&_input]:px-3 [&_input]:py-2 [&_input]:border [&_input]:rounded-md [&_input]:text-sm [&_input]:bg-background [&_select]:w-full [&_select]:px-3 [&_select]:py-2 [&_select]:border [&_select]:rounded-md [&_select]:text-sm [&_select]:bg-background [&_textarea]:w-full [&_textarea]:px-3 [&_textarea]:py-2 [&_textarea]:border [&_textarea]:rounded-md [&_textarea]:text-sm [&_textarea]:bg-background">{children}</div>
    </label>
  )
}
